import { ErrorCode, ResponceDataType } from "../../../ErrorCode"
import { IsConanAirPlc} from "../../../function/PlcNoModel";

//傾向管理アイテムType
export type TrendGraphPageDataType = {
  selectGroupNo: number;
  targetDay: string;
  dataUpDateTime: string;
};


//傾向管理アイテムType
export type TrendManagementSettingType = {
  PLCNo: string;
  AICardNo: string;
  ChannelNo: string;
  SettingNo: string;
  IsShow: boolean;
  GroupSetNo: number;
  PenNo: string;
  LineColor: string;
  Kind: number;
  MachineIndex: string;
  MachineName: string;
  ItemName: string;
  MeasureKindName: string;
  MeasureKindNo:number;
  TrendValueUpper: string;
  TrendValueUpperLimit: string;
  OperationProcess: string;
  UnitSymbol: string;
  Clc: number;
  TypeNo: number;
  TypeName: string;
  MCLCTypeID: number;
  MCLCTypeName: string;
  IsRowSelect: boolean;
  IndexNo: number;
  IsDataSelect: boolean;
};

export const createDefaltTrendSetting = () : TrendManagementSettingType  => {
  var ret: TrendManagementSettingType = {
    IndexNo: 0,
    PLCNo: "0",
    AICardNo: "0",
    ChannelNo: "0",
    SettingNo: "0",
    IsShow: false,
    GroupSetNo : 0,
    PenNo: "0",
    LineColor: "",
    Kind : 0,
    MachineIndex: "0",
    MachineName: "",
    ItemName: "",
    MeasureKindName: "",
    MeasureKindNo: 0,
    TrendValueUpper: "",
    TrendValueUpperLimit: "",
    OperationProcess: "",
    UnitSymbol: "",
    Clc: 0,
    TypeNo: 0,
    TypeName: "",
    MCLCTypeID : 0,
    MCLCTypeName : "",
    IsRowSelect: false,
    IsDataSelect :false,
  };

  return ret;
}

export type GraphDataType = {
    PLCNo: string;
    AICardNo: string;
    ChannelNo: string;
    SettingNo: string;
    ValueDateTime: Date[];
    Value: number[];
    UpperValue: number;
    UpperLimitValue:number;

    AlmTypeNo: number
    GraphY1MaxValue: number;
    GraphY1MinValue: number;
}

export type GraphDataListsType = {
  GraphDataList: GraphDataType[];

}

//傾向管理アイテム設定一覧を取得
export const GetTrendSettingList = (gropuNo: string | unknown) : Promise<TrendManagementSettingType[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/TrendSetting/" + gropuNo, {
      method: 'GET',
      headers: { pageName: 'TrendGraph' },
    })
    .then((res) => res.json())
      .then((result: TrendManagementSettingType[]) => {
        if (trendManagementSettingTypeListValidate(result)) resolve(result);

        if (result.length != 8) {
            var count: number = result.length;
            for (let i = 0; i < (8 - count); i++) {
              result.push(createDefaltTrendSetting());
            }
        }

        for (var i in result) {
          result[i].IndexNo = Number(i);
          result[i].IsRowSelect = false;
          result[i].IsDataSelect = false;
        }
        for (let i = 0; i < result.length; i++) {
        }

        reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const trendManagementSettingTypeListValidate = (data: TrendManagementSettingType[]) => {
    if (data == undefined) return false;
    return true;
  };


export const GetGraphDataListsType = (
  gropuNo: string | unknown,
  fromTime: string,
  toTime: string): Promise<GraphDataListsType> => {
  return new Promise((resolve, reject) => {

    var url: string = "api/TrendGraphModels/" + gropuNo;
    var timeBetween = `?fromtime=${fromTime}&totime=${toTime}`;

    console.debug(` GetGraphDataListsType -- ${url + timeBetween}`);
    fetch(url + timeBetween)
    .then((res) => res.json())
    .then((result: GraphDataListsType) => {
      if (GraphDataListsTypeValidate(result)) resolve(result);

      reject('Invalidate response');
    },
      (error) => {
        console.log(error);
        reject(error);
      }
  );
  });
};

const GraphDataListsTypeValidate = (data: GraphDataListsType) => {
   console.log(`TrandSettings ckeck ${data}`);
  if (data == undefined) return false;
   console.log("TrandSettings ckeck ok");
  return true;
};
